import React, { useState } from 'react';
import { useAuth } from '../App';
import MojeVykazy from '../components/MojeVykazy';
import NovyVykaz from '../components/NovyVykaz';
import SchvalovaniTym from '../components/SchvalovaniTym';
import PrehledJednatel from '../components/PrehledJednatel';
import SpravaSytemu from '../components/SpravaSytemu';
import ZmenaHesla from '../components/ZmenaHeslaModal';
import Dovolena from '../components/Dovolena';
import PrehledTym from '../components/PrehledTym';
 
const roleLabel = { zamestnanec: 'Zaměstnanec', vedouci: 'Vedoucí', jednatel: 'Jednatel', hr: 'HR / Admin' };
 
export default function Dashboard() {
  const { profile, logout } = useAuth();
  const [view, setView] = useState('vykazy');
  const [showNovy, setShowNovy] = useState(false);
  const [showHeslo, setShowHeslo] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
 
  const refresh = () => setRefreshKey(k => k + 1);
 
  const navItems = [
    { key: 'vykazy', label: 'Moje výkazy', roles: ['zamestnanec', 'vedouci', 'hr', 'jednatel'] },
    { key: 'schvaleni', label: 'Schválení', roles: ['vedouci', 'hr', 'jednatel'] },
    { key: 'dovolena', label: 'Dovolená', roles: ['zamestnanec', 'vedouci', 'jednatel', 'hr'] },
    { key: 'prehledtym', label: 'Přehled hodin', roles: ['vedouci'] },
    { key: 'prehled', label: 'Přehled', roles: ['jednatel', 'hr'] },
    { key: 'sprava', label: 'Správa', roles: ['hr', 'jednatel', 'vedouci'] },
  ].filter(n => n.roles.includes(profile.role));
 
  return (
    <div style={{ minHeight: '100vh', background: 'var(--gray-100)', fontFamily: 'DM Sans, sans-serif' }}>
      <header style={{ background: '#111111', height: 56, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 16px', position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 28, height: 28, background: '#2d6a4f', borderRadius: 7, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, flexShrink: 0 }}>⏱</div>
          <span style={{ fontFamily: 'DM Serif Display, serif', fontSize: 18, color: '#fff', whiteSpace: 'nowrap' }}>Výkazy práce</span>
        </div>
 
        <div style={{ position: 'relative' }}>
          <button onClick={() => setShowMenu(!showMenu)} style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8, padding: '7px 12px', color: '#fff', fontSize: 13, fontFamily: 'DM Sans, sans-serif', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}>
            <span>{profile.jmeno.split(' ')[0]}</span>
            <span style={{ fontSize: 10, opacity: 0.6 }}>▼</span>
          </button>
 
          {showMenu && (
            <div style={{ position: 'absolute', top: '110%', right: 0, background: '#fff', borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.18)', minWidth: 200, zIndex: 200, overflow: 'hidden' }}>
              <div style={{ padding: '14px 16px', borderBottom: '1px solid #f0f0f0' }}>
                <div style={{ fontWeight: 700, fontSize: 14, color: '#111' }}>{profile.jmeno}</div>
                <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{roleLabel[profile.role]}</div>
              </div>
              <button onClick={() => { setShowHeslo(true); setShowMenu(false); }} style={{ width: '100%', background: 'none', border: 'none', padding: '13px 16px', textAlign: 'left', fontSize: 14, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', color: '#333', fontWeight: 500, borderBottom: '1px solid #f0f0f0' }}>
                🔑 Změnit heslo
              </button>
              {profile.google_drive_url && (
                <a href={profile.google_drive_url} target="_blank" rel="noopener noreferrer" onClick={() => setShowMenu(false)}
                  style={{ width: '100%', background: 'none', border: 'none', padding: '13px 16px', textAlign: 'left', fontSize: 14, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', color: '#333', fontWeight: 500, borderBottom: '1px solid #f0f0f0', display: 'block', textDecoration: 'none' }}>
                  📁 Moje dokumenty
                </a>
              )}
              <button onClick={() => { logout(); setShowMenu(false); }} style={{ width: '100%', background: 'none', border: 'none', padding: '13px 16px', textAlign: 'left', fontSize: 14, cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', color: '#c0392b', fontWeight: 500 }}>
                → Odhlásit
              </button>
            </div>
          )}
        </div>
      </header>
 
      {showMenu && <div onClick={() => setShowMenu(false)} style={{ position: 'fixed', inset: 0, zIndex: 99 }} />}
 
      <nav style={{ background: '#fff', borderBottom: '1px solid var(--gray-200)', padding: '0 12px', display: 'flex', gap: 0, overflowX: 'auto' }}>
        {navItems.map(n => (
          <button key={n.key} onClick={() => setView(n.key)} style={{ background: 'none', border: 'none', padding: '14px 14px 12px', fontSize: 14, fontWeight: view === n.key ? 700 : 400, color: view === n.key ? '#1b4332' : '#888', borderBottom: view === n.key ? '2.5px solid #2d6a4f' : '2.5px solid transparent', fontFamily: 'DM Sans, sans-serif', whiteSpace: 'nowrap', cursor: 'pointer' }}>{n.label}</button>
        ))}
      </nav>
 
      <main style={{ maxWidth: 960, margin: '0 auto', padding: '20px 14px' }}>
        {view === 'vykazy' && (
          <>
            {(profile.role === 'zamestnanec' || profile.role === 'vedouci' || profile.role === 'hr' || profile.role === 'jednatel') && (
              <div style={{ marginBottom: 16 }}>
                <button className="btn-primary" onClick={() => setShowNovy(true)}>+ Přidat výkaz</button>
              </div>
            )}
            <MojeVykazy refreshKey={refreshKey} />
          </>
        )}
        {view === 'dovolena' && <Dovolena key={refreshKey} />}
        {view === 'schvaleni' && <SchvalovaniTym onRefresh={refresh} />}
        {view === 'prehledtym' && <PrehledTym key={refreshKey} />}
        {view === 'prehled' && <PrehledJednatel key={refreshKey} />}
        {view === 'sprava' && <SpravaSytemu key={refreshKey} onRefresh={refresh} />}
      </main>
 
      {showNovy && <NovyVykaz onClose={() => setShowNovy(false)} onSaved={() => { setShowNovy(false); refresh(); }} />}
      {showHeslo && <ZmenaHesla onClose={() => setShowHeslo(false)} />}
    </div>
  );
}
